import { useNavigate, useParams } from "react-router";
import { TokenPairIcon } from "../../components/ui/token-pairIcon.tsx";
// import { Button } from "../../components/ui/button.tsx";
import { ManageLiquidityPool } from "./components/manage-liquidity-pool.tsx";
import { SelectToken } from "./components/select-token.tsx";
import { TokenIcon } from "../../components/ui/token-icon.tsx";
import { Input } from "../../components/ui/input.tsx";
import { TradeSetting } from "./components/trade-setting.tsx";
import LPTokenSelectInput from "../../components/LPTokenSelectInput";
import { useTranslation } from "react-i18next";
import useDerivedLiquidity from "../../hooks/useDerivedLiquidity.js";
import Token from "../Token/index.js";
import useToken from "../../hooks/useToken.js";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, CardFooter, useDisclosure } from "@nextui-org/react";
import toast from "react-hot-toast";
import TxConfirmModal from "../../components/TxConfirmModal/index.js";
import { TradeConfirm } from "./components/trade-confirm.tsx";
import { SWAP_MODES } from "../../constants/trade.js";
import { ETHER } from "../../constants/types.js";
import useTokenSymbol from "../../hooks/useTokenSymbol.js";

export default function CreatePair() {
  const navigate = useNavigate();
  const { t } = useTranslation()
  const {
    swapMode,
    router,
    inputTokenAllowance,
    inputTokenApprove,
    inputTokenApproving,
    outputTokenAllowance,
    outputTokenApprove,
    outputTokenApproving,
    isNoLiquidity,
    swapMistake,
    networkFee,
    inputCurrency,
    onSelectInputCurrency,
    inputCurrencyBalance,
    outputCurrency,
    onSelectOutputCurrency,
    outputCurrencyBalance,
    amountIn,
    amountOut,
    setAmountIn,
    setAmountOut,
    onSwitchCurrency,
    estimating,
    amounts,
    path,
    gasPrice,
    gasLimit,
    outputReserve
  } = useDerivedLiquidity()
  const { tokenAAddress, tokenBAddress } = useParams();
  const [txHash, setTxHash] = useState(null)
  const { isOpen: isSwapOpen, onOpen: onSwapOpen, onOpenChange: onSwapOpenChange } = useDisclosure();
  const { isOpen: isSniperOpen, onOpen: onSniperOpen, onOpenChange: onSniperOpenChange } = useDisclosure();
  const { isOpen: isSubmittedOpen, onOpen: onSubmittedOpen, onOpenChange: onSubmittedOpenChange } = useDisclosure();
  const onSwapSubmit = useCallback((hash) => {
    setAmountIn('')
    setTxHash(hash)
    onSwapOpenChange()
    onSubmittedOpen()
  }, [onSwapOpenChange, setAmountIn, onSubmittedOpen])
  const [fixAmounts, setFixAmounts] = useState([])
  const inputCurrencySymbol = useTokenSymbol(inputCurrency)
  const outputCurrencySymbol = useTokenSymbol(outputCurrency)
  const onSniperCreate = useCallback(() => {
    setAmountIn('')
    onSniperOpenChange()
    toast.success(t("created"))
    navigate('/swap/orders')
  }, [onSniperOpenChange, setAmountIn, navigate, t])
  const amountInEnough = useMemo(() => {
    if (inputCurrency && amounts.length >= 2) {
      if (inputCurrency === ETHER) {
        return inputCurrencyBalance - networkFee >= amounts[0]
      }
      return inputCurrencyBalance >= amounts[0]
    }
    return null
  }, [inputCurrency, inputCurrencyBalance, amounts, networkFee])
  // 只在首次进入时初始化，可根据需要控制依赖
  const getFooterContent = () => {
    if (swapMode !== SWAP_MODES.ERC314 && inputCurrency !== ETHER && amounts.length >= 2 && inputTokenAllowance <= amounts[0]) {
      return (
        <Button
          size={'lg'}
          className={'w-full disabled:opacity-30 disabled:pointer-events-none bg-button'}
          color={"secondary"}
          variant={'flat'}
          isLoading={inputTokenApproving}
          onPress={inputTokenApprove}
        >
          {t("approve")} {inputCurrencySymbol}
        </Button>
      )
    }
    if (swapMode !== SWAP_MODES.ERC314 && outputCurrency !== ETHER && amounts.length >= 2 && outputTokenAllowance <= amounts[0]) {
      return (
        <Button
          size={'lg'}
          className={'w-full disabled:opacity-30 disabled:pointer-events-none bg-button'}
          color={"secondary"}
          variant={'flat'}
          isLoading={outputTokenApproving}
          onPress={outputTokenApprove}
        >
          {t("approve")} {outputCurrencySymbol}
        </Button>
      )
    }


    return (
      <Button
        size={'lg'}
        className={'w-full disabled:grayscale disabled:pointer-events-none bg-button text-black'}
        color={"primary"}
        variant={'flat'}
        disabled={!outputCurrency || !inputCurrency || amountIn <= 0 || amountOut <= 0 || amounts.length === 0 || !amountInEnough  }
        onPress={() => {
          setFixAmounts(amounts)
          onSwapOpen()
        }}
      >
        {amountInEnough === false ? `${inputCurrencySymbol}${t("insufficient")}` : "添加"}
      </Button>
    )
  }


  return (
    <div className="px-[24px]">
      <div className="bg-[#1A1C1E] text-white px-[20px] py-[15px] mb-[15px] rounded-lg">
        <div className="flex items-center justify-between mb-[10px]">
          <Button
            variant={"link"}
            className="!bg-[transparent] p-0 cursor-pointer"
            onPress={() => {
              navigate("/trade", { replace: true });
            }}
          >
            <img src="/assets/icons/back.png" alt="" width={12} height={12} />
          </Button>
          {/* <Link to="/trade" className="text-[12px] font-bold">
            <img src="/assets/icons/back.png" alt="" width={12} height={12} />
          </Link> */}
          <span className="text-[12px] font-bold">注入流动资金</span>

          <TradeSetting>
            <Button
              variant={"link"}
              className="!bg-[transparent] p-0 cursor-pointer"
            >
              <img
                src="/assets/icons/setting.png"
                alt=""
                width={12}
                height={12}
              />
            </Button>
          </TradeSetting>
        </div>
        <div className="w-full py-[12px] leading-[20px] rounded-lg text-[10px] font-regular bg-[#886C24] mb-[12px] px-[23px]">
          提示：当您注入流动资金时，您将收到代表您份额的流动池代币。这些代币将根据您在池中所占份额，自动赚取和累计相称的手续费，并且可以随时赎回流动池市对。
        </div>
        <div className="flex flex-col gap-y-[8px] items-center">
          <LPTokenSelectInput
            selectedCurrency={inputCurrency}
            onSelect={onSelectInputCurrency}
            currencyBalance={inputCurrencyBalance}
            amount={amountIn}
            onAmountChange={setAmountIn}
            disabled={false}
            networkFee={networkFee}
          />
          <span>+</span>
          <LPTokenSelectInput
            selectedCurrency={outputCurrency}
            onSelect={onSelectOutputCurrency}
            currencyBalance={outputCurrencyBalance}
            disabled={false}
            amount={amountOut}
            onAmountChange={setAmountOut}
          />
        </div>
        {/* <div className="bg-[#2C2F33] mt-2 rounded-lg">
          <div className="text-[10px] font-regular pt-[15px] px-[12px] pb-[11px]">
            兑换率和流动池份额
          </div>
          <div className="py-[12px] bg-[#25282B] flex items-center justify-around">
            <div className="text-[10px] font-regular flex items-center flex-col gap-y-[12px]">
              <p>0</p>
              <p>每</p>
            </div>
            <div className="text-[10px] font-regular flex items-center flex-col gap-y-[12px]">
              <p>0</p>
              <p>每</p>
            </div>
            <div className="text-[10px] font-regular flex items-center flex-col gap-y-[12px]">
              <p>0.00%</p>
              <p>流动池份额</p>
            </div>
          </div>
        </div> */}
        <div className="m-4">
          {getFooterContent()}

          <TradeConfirm onSubmit={onSwapSubmit} isOpen={isSwapOpen} onOpenChange={onSwapOpenChange} tokenA={inputCurrency} tokenB={outputCurrency} tokenAAmount={amountIn} tokenBAmount={amountOut} />

        </div>

      </div>
      {/* <div className="bg-[#1A1C1E] text-white px-[20px] py-[15px] rounded-lg">
        <div className="text-[10px] font-regular mb-[15px]">
          您的流动资金仓位
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <TokenPairIcon tokens={["BNB", "USDT"]} className="mr-[10px]" />
            <span className="text-[10px] font-regular">/</span>
          </div>
          <span className="text-[10px] font-regular">0</span>
        </div>
        <div className="space-y-[13px] mt-[22px]">
          <div className="text-[10px] font-regular flex justify-between">
            <span>您的流动池份额:</span>
            <span>0.000597</span>
          </div>
          <div className="text-[10px] font-regular flex justify-between">
            <span>:</span>
            <span>NAN</span>
          </div>
          <div className="text-[10px] font-regular flex justify-between">
            <span>:</span>
            <span>NAN</span>
          </div>
        </div>
      </div> */}
      <TxConfirmModal
        hash={txHash}
        isOpen={isSubmittedOpen}
        onOpenChange={onSubmittedOpenChange}
      />

    </div>
  );
}
